<template>
  <div class="fraud__content">
    <div class="fraud__form__wrapper" v-if="!fraudFind">
      <div class="fraud__form__switch">
        <p
          v-for="(item, index) in switchersMove"
          :class="{ selected: item.selected }"
          @click="switchMove(index)"
        >
          {{ item.name }}
        </p>
      </div>
      <div class="fraud__form" v-if="!fraudFind && switchersMove[0].selected">
        <div class="fraud__form__input">
          <span class="name">Limit level:</span>
          <div class="fraud__form__input__wrapper select" @click="openSelectLimitLevel">
            <p>{{ limitLevel }}</p>
            <img
              :class="{ rotate: selectLimitLevelOpen }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectLimitLevelOpen">
            <span
              class="select__dropDown__item"
              v-for="item in limitLevels"
              @click="selectLimitLevel(item)"
              :key="item"
            >
              {{ item }}
            </span>
          </div>
        </div>
        <div class="fraud__form__input">
          <span class="name">Type:</span>
          <div class="fraud__form__input__wrapper select" @click="openSelectType">
            <p>{{ type }}</p>
            <img
              :class="{ rotate: selectTypeOpen }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectTypeOpen">
            <span
              class="select__dropDown__item"
              v-for="type in types"
              @click="selectType(type)"
              :key="type"
            >
              {{ type }}
            </span>
          </div>
        </div>
        <div class="fraud__form__input">
          <span class="name">Value:</span>
          <div class="fraud__form__input__wrapper">
            <input type="text" placeholder="Value:" v-model="value" />
          </div>
        </div>
        <div class="fraud__form__input">
          <span class="name">Event:</span>
          <div class="fraud__form__input__wrapper select" @click="openSelectEvent">
            <p>{{ event }}</p>
            <img
              :class="{ rotate: selectEventOpen }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectEventOpen">
            <span
              class="select__dropDown__item"
              v-for="event in events"
              @click="selectEvent(event)"
              :key="event"
            >
              {{ event }}
            </span>
          </div>
        </div>
        <div class="fraud__form__input">
          <span class="name">Depth:</span>
          <div class="fraud__form__input__wrapper">
            <input type="text" placeholder="Depth:" v-model="depth" />
          </div>
        </div>
        <div class="fraud__form__input calendarInput">
          <span class="name"> Date: </span>
          <div id="app" class="fraud__calendar">
            <DatePicker
              v-on:input="getCorrectDate"
              v-bind:value="selectedDate"
              is-dark
              is-range
              v-if="openedCalendar"
              :modelConfig="modelConfig"
              :select-attribute="selectDragAttribute"
              :drag-attribute="selectDragAttribute"
              @drag="dragValue = $event"
            >
              <template v-slot:day-popover="{ format }">
                <div>
                  {{ format(dragValue ? dragValue.start : range.start, 'MMM D') }}
                  -
                  {{ format(dragValue ? dragValue.end : range.end, 'MMM D') }}
                </div>
              </template>
            </DatePicker>
          </div>
          <div class="fraud__form__input__wrapper calendarValue" @click="openCalendar">
            <span class="name">{{ valueDate }}</span>
            <button class="clear" @click="clearDate">Clear</button>
          </div>
        </div>
        <div class="fraud__form__wrapperBtn">
          <button class="fraud__form__find" @click="findFraud">Найти</button>
        </div>
        <p class="findMsg" v-if="showMsg">Введите другие данные</p>
        <p class="errorMsg" v-if="errorMsg">Ошибка</p>
        <p class="success" v-if="deleteUserFraud">Удалены</p>
      </div>
      <div class="fraud__form" v-if="!fraudFind && switchersMove[1].selected">
        <div class="fraud__form__input">
          <span class="name">Limit level:</span>
          <div class="fraud__form__input__wrapper select" @click="openSelectLimitLevel">
            <p>{{ limitLevelAdd }}</p>
            <img
              :class="{ rotate: selectLimitLevelOpen }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectLimitLevelOpen">
            <span
              class="select__dropDown__item"
              v-for="item in limitLevelsAdd"
              @click="selectLimitLevelAdd(item)"
              :key="item"
            >
              {{ item }}
            </span>
          </div>
        </div>
        <div class="fraud__form__input">
          <span class="name">2FA:</span>
          <div class="fraud__form__input__wrapper">
            <input type="text" placeholder="2FA:" v-model="twoFa" />
          </div>
        </div>
        <div class="fraud__form__wrapperBtn">
          <button
            class="fraud__form__find"
            :class="{ disable: !twoFa || addLoader }"
            @click="addFraud"
          >
            Добавить
          </button>
        </div>
        <Loader v-if="addLoader" />
        <p class="errorMsg" v-if="errorMsg">Ошибка</p>
        <p class="success" v-if="addUserFraud">Добавлен</p>
      </div>
      <div class="fraud__form" v-if="!fraudFind && switchersMove[2].selected">
        <div class="fraud__form__input">
          <span class="name">2FA:</span>
          <div class="fraud__form__input__wrapper">
            <input type="text" placeholder="2FA:" v-model="twoFa" />
          </div>
        </div>
        <div class="fraud__form__wrapperBtn">
          <button
            class="fraud__form__find"
            :class="{ disable: !twoFa || deleteLoader }"
            @click="deleteFraud"
          >
            Удалить
          </button>
        </div>
        <Loader v-if="deleteLoader" />
        <p class="errorMsg" v-if="errorMsg">Ошибка</p>
        <p class="success" v-if="deleteUserFraud">Удален</p>
      </div>
    </div>
    <div class="fraud__issuer" v-if="!fraudFind">
      <p class="fraud__issuer__title">{{ isIssuer }} Params</p>
      <div class="fraud__issuer__params">
        <div class="fraud__issuer__param" v-for="(param, index) in issuerParams">
          <div class="fraud__issuer__param__info">
            <input :placeholder="param.name" v-model="param.value" />
            <button @click="paramAddItem(index, param.value)" :class="{ disable: !param.value }">
              Добавить
            </button>
          </div>
          <div class="fraud__issuer__param__added" v-if="param.array.length">
            <span v-for="(addedItem, indexAdded) in param.array">
              {{ addedItem }}
              <img
                src="../../assets/images/close.svg"
                alt="delete"
                @click="deleteAddedItemParam(index, indexAdded)"
              />
            </span>
          </div>
        </div>
        <textarea placeholder="JSON" v-model="jsonIssuerParams" />
      </div>
    </div>
    <Loader v-if="loader" />
    <div class="fraud__wrapper__table" v-if="fraudRegistryInfo.length">
      <div class="fraud__wrapper__table__header">
        <div class="fraud__back" @click="backToFind">
          <img src="../../../src/assets/images/arrowLeft.svg" alt="arrowLeft" />
          <p>Вернуться на поиск</p>
        </div>
        <p class="errorMsg" v-if="jsonError">JSON формат неверный</p>
      </div>
      <table>
        <thead>
          <tr>
            <td>Source</td>
            <td>Relation</td>
            <td>Issuer Params</td>
            <td>Param type</td>
            <td>Param value</td>
            <td>Datetime</td>
            <td>Limit</td>
          </tr>
        </thead>
        <tbody>
          <TableRowFraud v-for="(row, index) in fraudRegistryInfo" :key="index" :row="row" />
        </tbody>
      </table>
      <div class="fraud__deleteSelectedItems" v-if="isDeleteFraudItems.length">
        <div class="fraud__form__input__wrapper">
          <input type="text" placeholder="2FA:" v-model="twoFaDeleteSelected" />
        </div>
        <div class="fraud__form__wrapperBtn">
          <button
            :class="{ disable: !twoFaDeleteSelected }"
            class="fraud__form__find"
            @click="deleteFraud"
          >
            Удалить
          </button>
        </div>
        <p class="errorMsg" v-if="errorMsg">Ошибка</p>
      </div>
    </div>
  </div>
</template>

<script>
import './fraudRegistry.scss'

import cookie from 'vue-cookie'

import { DatePicker } from 'v-calendar'
import TableRowFraud from '../../components/TableRowFraud/TableRowFraud'
import Loader from '../../components/Loader/Loader'

export default {
  name: 'FraudRegisrty',
  components: { Loader, DatePicker, TableRowFraud },
  data() {
    return {
      limitLevel: 'Select Limit level',
      limitLevelAdd: 'base',
      type: 'Select type',
      event: 'Select event',
      value: '',
      twoFa: '',
      twoFaDeleteSelected: '',
      depth: '',
      startDate: '',
      endDate: '',
      switchersMove: [
        {
          name: 'Поиск',
          selected: true
        },
        {
          name: 'Добавить',
          selected: false
        },
        {
          name: 'Удалить',
          selected: false
        }
      ],
      selectTypeOpen: false,
      selectLimitLevelOpen: false,
      selectEventOpen: false,
      loader: false,
      addLoader: false,
      deleteLoader: false,
      fraudFind: false,
      showMsg: false,
      jsonError: false,
      errorMsg: false,
      deleteUserFraud: false,
      addUserFraud: false,
      limitLevels: ['base', 'full'],
      limitLevelsAdd: ['base'],
      types: ['user_id'],
      events: [
        'gm_history',
        'payments.topup',
        'payments.topup.gm_callback',
        'payments.autowithdrawals',
        'admin',
        'trades.trade',
        'market.buy',
        'payments.withdraw',
        'payments.topup.payok_callback',
        'market.create',
        'items.withdraw',
        'items.deposit'
      ],
      jsonIssuerParams: '',
      issuerParams: [
        {
          array: [],
          value: '',
          name: 'user_id'
        },
        {
          array: [],
          value: '',
          name: 'username'
        },
        {
          array: [],
          value: '',
          name: 'ip'
        },
        {
          array: [],
          value: '',
          name: 'wallet'
        },
        {
          array: [],
          value: '',
          name: 'roblox_username'
        },
        {
          array: [],
          value: '',
          name: 'email'
        },
        {
          array: [],
          value: '',
          name: 'payment_system_invoice'
        },
        {
          array: [],
          value: '',
          name: 'withdrawal_id'
        },
        {
          array: [],
          value: '',
          name: 'topup_id'
        }
      ],
      dragValue: null,
      range: {
        start: new Date(2018, 0, 8),
        end: new Date(2018, 0, 12)
      },
      valueDate: 'Select a date',
      modelConfig: {
        type: 'string',
        mask: 'iso'
      },
      selectedDate: new Date(),
      openedCalendar: false,
      fraudRegistryInfo: []
    }
  },
  created() {
    this.initListeners()
    this.checkFraudRead()
    this.checkFraudAddFull()
  },
  destroyed() {
    this.initListeners()
  },
  computed: {
    selectDragAttribute() {
      return {
        popover: {
          visibility: 'hover',
          isInteractive: false
        }
      }
    },
    isIssuer() {
      if (this.switchersMove[0].selected) {
        return 'Issuer'
      }
      return ''
    },
    isPermissions() {
      return this.$store.state.permissions
    },
    isDeleteFraudItems() {
      return this.$store.state.deleteFraudItems
    }
  },
  methods: {
    switchMove(index) {
      if (index === 1 && !this.isPermissions.fraud_write_base) {
        return
      }
      if (index === 2 && !this.isPermissions.fraud_delete_base) {
        return
      }
      for (const switcher of this.switchersMove) {
        switcher.selected = false
      }
      this.clearParams()
      this.limitLevel = 'Select Limit level'
      this.twoFa = ''
      this.switchersMove[index].selected = true
    },
    checkFraudRead() {
      if (this.isPermissions.fraud_full_read) {
        this.types.push(
          'username',
          'ip',
          'wallet',
          'roblox_username',
          'email',
          'payment_system_invoice',
          'withdrawal_id',
          'topup_id'
        )
      }
    },
    checkFraudAddFull() {
      if (this.isPermissions.fraud_write_full) {
        this.limitLevelsAdd.push('full')
      }
    },
    openSelectLimitLevel() {
      this.selectLimitLevelOpen = !this.selectLimitLevelOpen
    },
    openSelectType() {
      this.selectTypeOpen = !this.selectTypeOpen
    },
    openSelectEvent() {
      this.selectEventOpen = !this.selectEventOpen
    },
    selectLimitLevel(limitLevel) {
      this.selectLimitLevelOpen = !this.selectLimitLevelOpen
      this.limitLevel = limitLevel
    },
    selectLimitLevelAdd(limitLevel) {
      this.selectLimitLevelOpen = !this.selectLimitLevelOpen
      this.limitLevelAdd = limitLevel
    },
    selectType(type) {
      this.selectTypeOpen = !this.selectTypeOpen
      this.type = type
    },
    selectEvent(event) {
      this.selectEventOpen = !this.selectEventOpen
      this.event = event
    },
    getCorrectDate(e) {
      this.startDate = `${e.start.split('.')[0]}`
      this.endDate = `${e.end.split('.')[0]}`
      this.valueDate = `${e.start.split('T')[0]} - ${e.end.split('T')[0]}`
    },
    openCalendar(event) {
      const path = event.path || (event.composedPath && event.composedPath())

      if (event && path.find((button) => button.classList && button.classList.contains('clear'))) {
      } else {
        this.openedCalendar = true
      }
    },
    clearParams() {
      for (const param of this.issuerParams) {
        param.array = []
      }
    },
    getCorrectParamsFraud() {
      const body = {}
      if (this.jsonIssuerParams) {
        try {
          body.issuer_params = JSON.parse(this.jsonIssuerParams)
        } catch (err) {
          this.jsonError = true
          setTimeout(() => {
            this.jsonError = false
          }, 2000)
        }
      } else {
        for (const param of this.issuerParams) {
          if (param.array.length) {
            if (!body.issuer_params) {
              body.issuer_params = {}
            }
            body.issuer_params[param.name] = param.array
          }
        }
      }
      if (this.limitLevel !== 'Select Limit level') {
        body.limit_level = this.limitLevel
      }
      if (this.type !== 'Select type') {
        body.type = this.type
      }
      if (this.value) {
        body.value = this.value
      }
      if (this.depth) {
        body.depth = this.depth
      }
      if (this.event !== 'Select event') {
        body.event = this.event
      }
      if (this.startDate) {
        body.from_datetime = this.startDate
      }
      if (this.endDate) {
        body.till_datetime = this.endDate
      }
      return body
    },
    getCorrectAddParams() {
      const body = {}
      if (this.jsonIssuerParams) {
        try {
          body.params = JSON.parse(this.jsonIssuerParams)
        } catch (err) {
          this.jsonError = true
          setTimeout(() => {
            this.jsonError = false
          }, 2000)
        }
      } else {
        for (const param of this.issuerParams) {
          if (param.array.length) {
            if (!body.params) {
              body.params = {}
            }
            body.params[param.name] = param.array
          }
        }
      }
      body.event = 'admin'
      body.limit_level = this.limitLevelAdd
      body.code = this.twoFa
      return body
    },
    getCorrectDeleteParams() {
      const body = {}
      if (this.switchersMove[2].selected) {
        if (this.jsonIssuerParams) {
          try {
            body.params = JSON.parse(this.jsonIssuerParams)
          } catch (err) {
            this.jsonError = true
            setTimeout(() => {
              this.jsonError = false
            }, 2000)
          }
        } else {
          for (const param of this.issuerParams) {
            if (param.array.length) {
              if (!body.params) {
                body.params = {}
              }
              body.params[param.name] = param.array
            }
          }
        }
        body.code = this.twoFa
      } else {
        body.ids = this.isDeleteFraudItems
        body.code = this.twoFaDeleteSelected
      }
      return body
    },
    async findFraud() {
      this.loader = true
      this.fraudFind = true
      const response = await fetch(
        `https://admin.neuralgeneration.com/api/utils/get_recent_limits`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${cookie.get('token')}`
          },
          body: JSON.stringify(this.getCorrectParamsFraud())
        }
      )
        .then((res) => {
          if (res.status !== 200) {
            this.fraudFind = false
            this.errorMsg = true
            setTimeout(() => {
              this.errorMsg = false
            }, 2000)
          }
          return res.json()
        })
        .then((data) => {
          if (!data.length) {
            this.showMsg = true
            setTimeout(() => {
              this.showMsg = false
            }, 2000)
            this.fraudFind = false
          }
          this.fraudRegistryInfo = data
        })
      this.loader = false
    },
    async addFraud() {
      this.addLoader = true
      const response = await fetch(`https://admin.neuralgeneration.com/api/utils/ask_check`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify(this.getCorrectAddParams())
      })
        .then((res) => {
          if (res.status !== 200) {
            this.errorMsg = true
            setTimeout(() => {
              this.errorMsg = false
            }, 2000)
          }
          return res.json()
        })
        .then((data) => {
          if (data.status) {
            this.addUserFraud = true
            this.clearParams()
            setTimeout(() => {
              this.addUserFraud = false
            }, 2000)
          } else {
            this.errorMsg = true
            setTimeout(() => {
              this.errorMsg = false
            }, 2000)
          }
        })
      this.addLoader = false
    },
    async deleteFraud() {
      this.deleteLoader = true
      const response = await fetch(`https://admin.neuralgeneration.com/api/utils/drop_limit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify(this.getCorrectDeleteParams())
      })
        .then((res) => {
          if (res.status !== 200) {
            this.errorMsg = true
            setTimeout(() => {
              this.errorMsg = false
            }, 2000)
          }
          return res.json()
        })
        .then((data) => {
          if (data.status) {
            this.deleteUserFraud = true
            this.clearParams()
            this.backToFind()
            this.twoFaDeleteSelected = ''
            setTimeout(() => {
              this.deleteUserFraud = false
            }, 2000)
          } else {
            this.errorMsg = true
            setTimeout(() => {
              this.errorMsg = false
            }, 2000)
          }
        })
      this.deleteLoader = false
    },
    backToFind() {
      this.twoFaDeleteSelected = ''
      this.fraudFind = false
      this.fraudRegistryInfo = []
      this.$store.commit('setDeleteFraudItems', [])
      this.type = 'Select type'
      this.event = 'Select event'
    },
    paramAddItem(index, value) {
      this.issuerParams[index].array.push(value)
      this.issuerParams[index].value = ''
    },
    deleteAddedItemParam(indexIssuerParam, indexItem) {
      this.issuerParams[indexIssuerParam].array.splice(indexItem, 1)
    },
    clearDate() {
      this.startDate = ''
      this.endDate = ''
      this.valueDate = 'Select a date'
    },
    initListeners() {
      document.addEventListener('click', this.closeByClickingOut)
    },
    closeByClickingOut(event) {
      const path = event.path || (event.composedPath && event.composedPath())

      if (
        event &&
        !path.find(
          (div) =>
            div.classList &&
            (div.classList.contains('searchPanel__calendar') ||
              div.classList.contains('calendarInput'))
        )
      ) {
        this.openedCalendar = false
      }
    }
  }
}
</script>
